export default {
  ftime: (value) => {
    // dd/mm/yyyy
    let date
    if (value) {
      // console.log('fdatetime', typeof value)
      if (value.toString() === value) {
        date = new Date(value.toString().substring(0, 19))
      } else {
        date = new Date(value.toISOString().substring(0, 19))
      }
      return date.toLocaleDateString(['th-TH'], { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }).substr(11, 5)
    } else {
      return ''
    }
  },
  fdatetime: (value) => {
    // dd/mm/yyyy
    let date
    if (value) {
      // console.log('fdatetime', typeof value)
      if (value.toString() === value) {
        date = new Date(value.toString().substring(0, 19))
      } else {
        date = new Date(value)
      }
      return date.toLocaleDateString(['th-TH'], { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    } else {
      return ''
    }
  },
  fdate: (value) => {
    let date
    if (value) {
      if (value.toString() === value) {
        date = new Date(value.toString().substring(0, 19))
      } else {
        date = new Date(value)
      }
      return date.toLocaleDateString(['th-TH'], { month: '2-digit', day: '2-digit', year: 'numeric' })
    } else {
      return ''
    }
  },
  fdate1: (value) => {
    let date
    if (value) {
      if (value.toString() === value) {
        date = new Date(value.toString().substring(0, 19))
      } else {
        date = new Date(value)
      }
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return date.toLocaleDateString(['th-TH'], options)
    } else {
      return ''
    }
  },
  fdatetimeEng: (value) => {
    // dd/mm/yyyy
    let date
    if (value) {
      // console.log('fdatetime', typeof value)
      if (value.toString() === value) {
        date = new Date(value.toString().substring(0, 19))
      } else {
        date = new Date(value)
      }
      return date.toLocaleDateString(['en-EN'], { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    } else {
      return ''
    }
  },
  fdateEng: (value) => {
    let date
    if (value) {
      if (value.toString() === value) {
        date = new Date(value.toString().substring(0, 19))
      } else {
        date = new Date(value)
      }
      return date.toLocaleDateString(['en-EN'], { month: '2-digit', day: '2-digit', year: 'numeric' })
    } else {
      return ''
    }
  },
  fdateEng1: (value) => {
    let date
    if (value) {
      if (value.toString() === value) {
        date = new Date(value.toString().substring(0, 19))
      } else {
        date = new Date(value)
      }
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return date.toLocaleDateString(['en-EN'], options)
    } else {
      return ''
    }
  },
  fdatedif: (value) => {
    let months = 0
    let date
    if (value) {
      const curDate = new Date()
      if (value.toString() === value) {
        date = new Date(value.toString().substring(0, 19))
      } else {
        date = new Date(value)
      }
      var timeDiff = Math.abs(curDate.getTime() - date.getTime())
      var diffDays = Math.ceil(timeDiff / (1000 * 60))
      if (diffDays <= 60) {
        return diffDays + ' นาทีที่ผ่านมา'
      }
      diffDays = Math.trunc(timeDiff / (1000 * 60 * 60))
      if (diffDays <= 24) {
        return diffDays + ' ชั่วโมงที่ผ่านมา'
      }
      diffDays = Math.trunc(timeDiff / (1000 * 60 * 60 * 24))
      if (diffDays > 30) {
        months = (curDate.getFullYear() - date.getFullYear()) * 12;
        months -= date.getMonth();
        months += curDate.getMonth();
        // diffDays = Math.abs(curDate.getDate() - date.getDate())
        if (months >= 12) {
          return Math.floor(months / 12) + ' ปีที่แล้ว'
        }
        return months + ' เดือนที่ผ่านมา'
      }
      return diffDays + ' วันที่ผ่านมา'
    }
  },
  fdatedif2: (value, value2) => {
    let date, curDate
    if (value && value2) {
      if (value !== value2) {
        if (value.toString() === value) {
          curDate = new Date(value2.toString().substring(0, 19))
        } else {
          curDate = new Date(value2)
        }
        if (value.toString() === value) {
          date = new Date(value.toString().substring(0, 19))
        } else {
          date = new Date(value)
        }
        var timeDiff = Math.abs(curDate.getTime() - date.getTime())
        var diffDays = Math.ceil(timeDiff / (1000 * 60))
        if (diffDays <= 60) {
          return diffDays + ' นาที'
        }
        diffDays = Math.trunc(timeDiff / (1000 * 60 * 60))
        if (diffDays <= 24) {
          return diffDays + ' ชั่วโมง'
        }
        diffDays = Math.trunc(timeDiff / (1000 * 60 * 60 * 24))
        return diffDays + ' วัน'
      } else {
        return '1 วัน'
      }
    }
  },
  currency: (value, digit = 2, prefix = '', postfix = '') => {
    return prefix + Intl.NumberFormat('th-TH', {
      minimumFractionDigits: digit,
      maximumFractionDigits: digit
    }).format(value) + postfix
    //return prefix + Number(parseFloat(value).toFixed(digit)).toLocaleString()+ postfix
  }
}